module.exports = __webpack_public_path__ + "static/media/xxGray.1464ea7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xxGray.png
// module id = 1873
// module chunks = 0 1